import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SwiperDirective } from '@src/app/@shared/directives/carousel.directive';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';

// register Swiper custom elements
register();

@NgModule({
  imports: [CommonModule, SwiperDirective, PlIconModule],
  declarations: [CarouselComponent],
  exports: [CarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselModule {}
